// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__OrGbw","col":"styles_col__3pfRQ"};